/* =========================================================================
   Selin Beauty — "2 Al 1 Öde + Hediye" kampanya arayüzü
   -------------------------------------------------------------------------
   Sorumluluk: YALNIZCA arayüz ve sepet satırı yönetimi.
   Fiyat indirimi tema tarafında HESAPLANMAZ — onu Shopify discount function
   yapar (sf-kampanya-discount). Burada yapılan tek şey:

     1. 2. ücretli ürün eklendiğinde konfetili tebrik penceresini açmak
     2. Hediye ürününü `_sb_hediye: "1"` damgasıyla sepete eklemek
        (function bu damgayı arar; damgasız satır bedava olmaz)
     3. Sepet sayfasında hediye seçim kartlarını sürmek
     4. GUARD: hediye hakkı düşerse hediye satırını sepetten çıkarmak

   Neden guard şart: müşteri hediyeyi ekleyip sonra ürünleri silerse function
   indirimi geri çeker ve müşteri hediyeyi TAM FİYATLA ödemek zorunda kalır.
   Sessizce satırı kaldırmak, sürpriz ücretten iyidir.
   ========================================================================= */
(function () {
  'use strict';

  var CFG = null;
  var busy = false;
  var lastPaidUnits = -1;

  function readConfig() {
    var el = document.getElementById('sb-kampanya-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /* ---------------------------------------------------------------- sepet */

  function getCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { Accept: 'application/json' },
    }).then(function (r) {
      return r.json();
    });
  }

  function isGiftLine(item) {
    var p = item.properties || {};
    return p._sb_hediye === '1' || p._sb_hediye === 1;
  }

  /**
   * Ücretli birim sayısı. Hediye satırları sayılmaz — function tarafındaki
   * kuralla birebir aynı olmalı, yoksa arayüz "hak kazandın" derken indirim
   * uygulanmaz (ya da tersi).
   *
   * original_price kullanılır, final_price DEĞİL: 2 al 1 öde uygulandığında
   * bedava olan satırın final_price'ı 0 olur; final_price'a bakarsak o satır
   * sayımdan düşer, hak kaybolur, guard hediyeyi siler ve indirim geri gelir —
   * sonsuz salınım.
   */
  function countPaidUnits(cart) {
    var n = 0;
    (cart.items || []).forEach(function (item) {
      if (isGiftLine(item)) return;
      if (!(item.original_price > 0)) return;
      n += item.quantity;
    });
    return n;
  }

  function giftLines(cart) {
    return (cart.items || []).filter(isGiftLine);
  }

  function addGift(variantId) {
    if (busy) return Promise.resolve(null);
    busy = true;
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
            // DAMGA — function yalnızca bu damgayı taşıyan VE hediye
            // listesinde bulunan satırı bedava yapar.
            properties: { _sb_hediye: '1' },
          },
        ],
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .finally(function () {
        busy = false;
      });
  }

  function removeLineByKey(key) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    }).then(function (r) {
      return r.json();
    });
  }

  /* --------------------------------------------------------------- guard  */

  /**
   * Hediye satırlarını hakka göre düzeltir.
   *  - hak yoksa    → hepsini kaldır
   *  - fazla varsa  → fazlasını kaldır (yalnızca maxGifts adet kalır)
   * Değişiklik yaptıysa true döner (çağıran sayfayı tazeler).
   */
  function enforceGiftEligibility(cart) {
    var gifts = giftLines(cart);
    if (gifts.length === 0) return Promise.resolve(false);

    var paid = countPaidUnits(cart);
    var allowed = paid >= CFG.minPaidUnits ? CFG.maxGifts : 0;

    var toRemove = [];
    var kept = 0;
    gifts.forEach(function (g) {
      if (kept < allowed && g.quantity === 1) {
        kept += 1;
      } else if (kept < allowed && g.quantity > 1) {
        // Aynı hediye satırında birden fazla adet varsa fazlası kaldırılır.
        kept += 1;
        toRemove.push({ key: g.key, quantity: 1 });
      } else {
        toRemove.push({ key: g.key, quantity: 0 });
      }
    });

    if (toRemove.length === 0) return Promise.resolve(false);

    return toRemove
      .reduce(function (chain, t) {
        return chain.then(function () {
          return fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ id: t.key, quantity: t.quantity }),
          });
        });
      }, Promise.resolve())
      .then(function () {
        return true;
      });
  }

  /* -------------------------------------------------------------- konfeti */

  function fireConfetti(canvas) {
    if (!canvas || !canvas.getContext) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var ctx = canvas.getContext('2d');
    var dpr = window.devicePixelRatio || 1;
    var w = canvas.clientWidth;
    var h = canvas.clientHeight;
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    ctx.scale(dpr, dpr);

    var colors = ['#D5B86E', '#C79E36', '#B8962E', '#F3E7C6', '#ffffff'];
    var parts = [];
    for (var i = 0; i < 90; i++) {
      parts.push({
        x: w / 2 + (Math.random() - 0.5) * w * 0.6,
        y: -20 - Math.random() * h * 0.3,
        vx: (Math.random() - 0.5) * 2.4,
        vy: 1.6 + Math.random() * 2.6,
        size: 4 + Math.random() * 5,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.22,
        color: colors[(Math.random() * colors.length) | 0],
      });
    }

    var started = performance.now();
    function frame(now) {
      var elapsed = now - started;
      ctx.clearRect(0, 0, w, h);
      parts.forEach(function (p) {
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.015;
        p.rot += p.vr;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.globalAlpha = Math.max(0, 1 - elapsed / 2600);
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
        ctx.restore();
      });
      if (elapsed < 2600) requestAnimationFrame(frame);
      else ctx.clearRect(0, 0, w, h);
    }
    requestAnimationFrame(frame);
  }

  /* --------------------------------------------------------------- popup  */

  function popupSeen() {
    try {
      return sessionStorage.getItem('sb_hediye_popup') === '1';
    } catch (e) {
      return false;
    }
  }
  function markPopupSeen() {
    try {
      sessionStorage.setItem('sb_hediye_popup', '1');
    } catch (e) {
      /* gizli sekmede sessionStorage yazılamaz — yoksay */
    }
  }
  function resetPopupSeen() {
    try {
      sessionStorage.removeItem('sb_hediye_popup');
    } catch (e) {}
  }

  function openPopup() {
    var dlg = document.getElementById('sb-hediye-modal');
    if (!dlg || dlg.open) return;
    if (typeof dlg.showModal !== 'function') return;
    dlg.showModal();
    markPopupSeen();
    fireConfetti(dlg.querySelector('.sb-confetti'));
    // Pencere kapalıyken genişlik 0 olduğu için gösterge yanlış hesaplanır;
    // açıldıktan sonra yeniden kurulur.
    var liste = dlg.querySelector('[data-sb-gift-list]');
    if (liste) {
      setTimeout(function () {
        noktalariKur(liste);
      }, 80);
    }
  }

  /* ------------------------------------------------------------ kart cizimi */

  function cardMarkup(g, chosen) {
    var out = '';
    out += '<div class="sb-gift-card' + (chosen ? ' is-chosen' : '') + '">';
    if (g.image) {
      out +=
        '<img class="sb-gift-card__img" src="' +
        g.image +
        '" alt="" loading="lazy" width="120" height="120">';
    }
    out += '<div class="sb-gift-card__body">';
    out += '<span class="sb-gift-card__title">' + g.title + '</span>';
    out += '<span class="sb-gift-card__price"><s>' + g.price + '</s> Ücretsiz</span>';
    out += '</div>';
    if (chosen) {
      out += '<span class="sb-gift-card__chosen">Seçildi</span>';
    } else if (g.available === false) {
      out += '<span class="sb-gift-card__soldout">Stokta yok</span>';
    } else {
      out +=
        '<button type="button" class="sb-gift-card__btn" data-sb-gift="' +
        g.id +
        '">Hediyemi Seç</button>';
    }
    out += '</div>';
    return out;
  }

  function renderLists(cart) {
    var chosenIds = giftLines(cart).map(function (l) {
      return l.variant_id;
    });
    var html = CFG.gifts
      .map(function (g) {
        return cardMarkup(g, chosenIds.indexOf(g.id) !== -1);
      })
      .join('');

    var full = chosenIds.length >= CFG.maxGifts;

    document.querySelectorAll('[data-sb-gift-list]').forEach(function (host) {
      host.innerHTML = html;
      host.classList.toggle('sb-gift-list--full', full);
      noktalariKur(host);
    });

    var paid = countPaidUnits(cart);
    var eligible = paid >= CFG.minPaidUnits;
    document.querySelectorAll('[data-sb-gift-section]').forEach(function (sec) {
      sec.hidden = !eligible;
    });
    document.querySelectorAll('[data-sb-gift-note]').forEach(function (n) {
      n.textContent = full
        ? 'Hediyeni seçtin. Değiştirmek için sepetten çıkarıp yeniden seçebilirsin.'
        : 'Aşağıdaki ürünlerden birini ücretsiz ekleyebilirsin.';
    });
  }

  /* --------------------------------------------------------------- akis   */

  function refresh(opts) {
    opts = opts || {};
    return getCart().then(function (cart) {
      return enforceGiftEligibility(cart).then(function (changed) {
        if (changed) {
          // Sepet değişti: sayfayı tazeleyip doğru fiyatları göster.
          if (isCartPage()) {
            window.location.reload();
            return;
          }
          return getCart().then(function (fresh) {
            renderLists(fresh);
          });
        }

        var paid = countPaidUnits(cart);
        renderLists(cart);

        // Popup: ücretli birim eşiği İLK kez geçildiğinde ve hediye henüz
        // seçilmemişken. Eşik altına düşülürse damga sıfırlanır (müşteri
        // yeniden 2 ürüne çıkarsa popup tekrar çıkabilsin).
        if (paid < CFG.minPaidUnits) {
          resetPopupSeen();
        } else if (
          opts.allowPopup &&
          giftLines(cart).length === 0 &&
          !popupSeen() &&
          CFG.gifts.length > 0
        ) {
          openPopup();
        }
        lastPaidUnits = paid;
      });
    });
  }

  function isCartPage() {
    return (
      document.body.classList.contains('template-cart') ||
      window.location.pathname.indexOf('/cart') === 0
    );
  }

  /* ------------------------------------------- tema promosyon penceresi ---
     Temanın kendi "Promotion popup" bölümü her ziyarette açılıyordu. Tema
     ayarındaki "bir sonraki gösterim" alanı en fazla 40 dakikaya izin veriyor
     (varsayılan 5 dk), yani "bugün bir daha gösterme" o ayarla yapılamıyor.
     Bu yüzden kendi damgamızı tutuyoruz.

     Kural (Faruk, 2026-08-14):
       - Pencere içinde herhangi bir yere tıklanırsa (buton veya çarpı) →
         o gün bir daha gösterme
       - Sepet sayfasında hiç gösterme
  */

  var PROMO_KEY = 'sb_promo_kapali_gun';

  function bugununDamgasi() {
    var d = new Date();
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
  }

  function promoBugunKapali() {
    try {
      return localStorage.getItem(PROMO_KEY) === bugununDamgasi();
    } catch (e) {
      return false;
    }
  }

  /**
   * Temanın kendi susturma çerezini 24 saatlik yeniden yazar.
   *
   * Tema, pencereyi `promotion-popup<themeId>` çerezine bakarak gizliyor ama
   * kapatınca yazdığı süre tema ayarıyla sınırlı (en fazla 40 dakika, varsayılan
   * 5). Aynı çerezi 24 saatlik yazınca tema kendi kontrolünde pencereyi
   * göstermiyor — yani susturma temanın kendi mekanizmasıyla garantiye alınıyor,
   * yalnızca bizim JS'imize bağlı kalmıyor.
   */
  function promoTemaCerezYaz() {
    try {
      var t = window.Shopify && window.Shopify.theme && window.Shopify.theme.id;
      if (!t) return;
      var d = new Date();
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
      document.cookie =
        'promotion-popup' + t + '=close; expires=' + d.toUTCString() + '; path=/';
    } catch (e) {}
  }

  function promoBugunKapat() {
    try {
      localStorage.setItem(PROMO_KEY, bugununDamgasi());
    } catch (e) {
      /* gizli sekmede yazılamaz - yoksay */
    }
    promoTemaCerezYaz();
    // Tema kendi (kısa süreli) çerezini bizden SONRA yazabiliyor; üstüne yaz.
    setTimeout(promoTemaCerezYaz, 120);
  }

  function promoKaldir() {
    var found = false;
    document.querySelectorAll('promotion-popup').forEach(function (el) {
      var dlg = el.querySelector('modal-dialog');
      if (dlg && typeof dlg.close === 'function') {
        try {
          dlg.close();
        } catch (e) {}
      }
      el.remove();
      found = true;
    });
    if (found) {
      // Pencere açılırken gövdeye kaydırma kilidi konmuş olabilir; kaldır.
      document.body.classList.remove('overflow-hidden');
      document.body.style.paddingRight = '';
    }
  }

  function promoKontrol() {
    var kapat = isCartPage() || promoBugunKapali();

    if (kapat) {
      // Bölüm geç yüklenebiliyor (tema kendi zamanlayıcısıyla açıyor);
      // birkaç kez dene, ayrıca DOM'a eklenmesini de izle.
      promoKaldir();
      [0, 100, 400, 1200, 2500, 4000].forEach(function (ms) {
        setTimeout(promoKaldir, ms);
      });
      if (typeof MutationObserver === 'function') {
        var mo = new MutationObserver(function () {
          promoKaldir();
        });
        mo.observe(document.documentElement, { childList: true, subtree: true });
        setTimeout(function () {
          mo.disconnect();
        }, 15000);
      }
      return;
    }

    // Pencere içindeki her tıklama (buton, bağlantı, çarpı) günü damgalar.
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (t.closest('promotion-popup, .promotion-popup')) {
          promoBugunKapat();
        }
      },
      true,
    );
    // Escape ile kapatma da sayılır.
    document.body.addEventListener('modalClosed', function () {
      if (document.querySelector('promotion-popup')) promoBugunKapat();
    });
  }

  /* ------------------------------------------- mobil kaydırma göstergesi -- */

  function noktalariKur(host) {
    var kap = host.closest ? host.closest('.sb-carousel') : null;
    var dots = kap ? kap.querySelector('[data-sb-dots]') : null;
    var okSol = kap ? kap.querySelector('.sb-ok--sol') : null;
    var okSag = kap ? kap.querySelector('.sb-ok--sag') : null;
    if (!dots) return;

    // Yalnızca yatay kaydırma varken anlamlı (mobil). Masaüstünde ızgara
    // olduğu için taşma olmaz; oklar ve noktalar gizli kalır.
    var kaydirmaVar = host.scrollWidth > host.clientWidth + 4;
    dots.hidden = !kaydirmaVar;
    if (okSol) okSol.hidden = !kaydirmaVar;
    if (okSag) okSag.hidden = !kaydirmaVar;
    if (!kaydirmaVar) {
      dots.innerHTML = '';
      return;
    }

    var kartlar = host.querySelectorAll('.sb-gift-card');
    if (dots.childElementCount !== kartlar.length) {
      var html = '';
      for (var i = 0; i < kartlar.length; i++) {
        html += '<span class="sb-dot"></span>';
      }
      dots.innerHTML = html;
    }

    function guncelle() {
      var kart = host.querySelector('.sb-gift-card');
      if (!kart) return;
      var adim = kart.offsetWidth + 10; /* kart + boşluk */
      var aktif = Math.round(host.scrollLeft / adim);
      dots.querySelectorAll('.sb-dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === aktif);
      });
      // Şeridin başındaysak sol ok, sonundaysak sağ ok sönümlensin.
      if (okSol) okSol.disabled = host.scrollLeft <= 2;
      if (okSag) {
        okSag.disabled =
          host.scrollLeft + host.clientWidth >= host.scrollWidth - 2;
      }
    }
    guncelle();

    if (!host.dataset.sbDotsBound) {
      host.dataset.sbDotsBound = '1';
      var raf = null;
      host.addEventListener(
        'scroll',
        function () {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = null;
            guncelle();
          });
        },
        { passive: true },
      );
    }
  }

  /* ---------------------------------------------------------------- init  */

  function init() {
    // Tema promosyon penceresi kontrolü kampanya verisinden bağımsız çalışır.
    promoKontrol();

    CFG = readConfig();
    if (!CFG || !CFG.enabled || !Array.isArray(CFG.gifts) || CFG.gifts.length === 0) {
      return;
    }

    // Hediye seçimi (popup + sepet listesi ortak).
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sb-gift]');
      if (btn) {
        e.preventDefault();
        var id = parseInt(btn.getAttribute('data-sb-gift'), 10);
        if (!id) return;
        btn.disabled = true;
        addGift(id).then(function () {
          var dlg = document.getElementById('sb-hediye-modal');
          if (dlg && dlg.open) dlg.close();
          // Faruk kararı (2026-08-14): hediye seçildikten sonra müşteri sepet
          // sayfasına geçsin — kampanya özetini ve toplamı orada görür.
          window.location.href = window.Shopify.routes.root + 'cart';
        });
        return;
      }
      // Şerit okları: bir kart genişliği kadar kaydır.
      var okBtn = e.target.closest('[data-sb-kaydir]');
      if (okBtn) {
        e.preventDefault();
        var kap = okBtn.closest('.sb-carousel');
        var liste = kap ? kap.querySelector('[data-sb-gift-list]') : null;
        if (liste) {
          var kart = liste.querySelector('.sb-gift-card');
          var adim = kart ? kart.offsetWidth + 10 : liste.clientWidth * 0.8;
          var yon = Number(okBtn.getAttribute('data-sb-kaydir')) || 1;
          liste.scrollBy({ left: adim * yon, behavior: 'smooth' });
        }
        return;
      }

      if (e.target.closest('[data-sb-close]')) {
        var d = document.getElementById('sb-hediye-modal');
        if (d && d.open) d.close();
      }
    });

    // Arka planda tıklayınca kapansın (light dismiss).
    var dlg = document.getElementById('sb-hediye-modal');
    if (dlg) {
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) dlg.close();
      });
    }

    // Aynı sepet olayı birden çok kanaldan gelebilir (pub/sub + fetch yakalama);
    // arka arkaya gelen tetiklemeleri tek çalıştırmada topla.
    var timer = null;
    function schedule(allowPopup) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        timer = null;
        refresh({ allowPopup: allowPopup });
      }, 250);
    }

    // Temanın sepet olayına bağlan.
    //
    // TUZAK: tema `PUB_SUB_EVENTS`i `const` ile tanımlıyor. `const` ve `let`
    // ile tanımlanan üst düzey değişkenler window nesnesine EKLENMEZ (yalnızca
    // `var` ve fonksiyon bildirimleri eklenir). Bu yüzden `window.PUB_SUB_EVENTS`
    // undefined'dır ve ona bakan bir koşul sessizce hiç çalışmaz.
    // Doğrusu: global kapsamdan `typeof` ile okumak.
    var events = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
    var sub =
      typeof subscribe === 'function'
        ? subscribe
        : typeof window.subscribe === 'function'
          ? window.subscribe
          : null;
    if (sub && events && events.cartUpdate) {
      sub(events.cartUpdate, function () {
        schedule(true);
      });
    }

    // YEDEK KANAL: sepet çağrılarını yakala. Tema hangi yolu kullanırsa kullansın
    // (yan çekmece, bildirim kutusu, hızlı ekle, uygulama widget'ı) sepet
    // değişikliği burada görülür. pub/sub kanalı kopsa da popup çalışır.
    var origFetch = window.fetch;
    if (typeof origFetch === 'function') {
      window.fetch = function () {
        var arg = arguments[0];
        var href = typeof arg === 'string' ? arg : (arg && arg.url) || '';
        var out = origFetch.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)/.test(href)) {
          out
            .then(function (res) {
              schedule(/\/cart\/add/.test(href));
              return res;
            })
            .catch(function () {});
        }
        return out;
      };
    }

    // Sepet sayfasındaki miktar değişiklikleri pub/sub yayınlamaz; formu izle.
    if (isCartPage()) {
      document.addEventListener('change', function (e) {
        if (e.target && e.target.matches && e.target.matches('.quantity__input')) {
          schedule(false);
        }
      });
    }

    refresh({ allowPopup: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
